/* Wild Foods — "Notify Me" handler (shared).

   Any element carrying [data-wf-notify] scrolls to the WF Newsletter CTA and
   focuses its email field. Products tagged "Coming Soon" render this instead
   of an Add to cart button, across WF Products, WF Collection, WF Recipe Shop
   and the product page.

   WHY THIS IS A SHARED FILE
   The handler is delegated on document, so it only needs to run once per page
   — but it originally shipped as an inline copy inside each section. That
   meant a section could render a Notify button with no handler attached if it
   happened to be the only WF section on the page, which is exactly what went
   wrong on recipe articles: WF Recipe Shop rendered the button, but none of
   the sections carrying the handler were on that page, so clicking did
   nothing. Loading it once from the footer group removes that whole class of
   bug — a new section only has to emit [data-wf-notify] and it works.

   Loaded from sections/wf-cta-newsletter.liquid, which lives in the footer
   group and is therefore on every page — and is also the scroll target, so
   the script and its destination can never be separated.

   The window.wfNotifyBound guard is kept because older inline copies still
   exist in some sections; whichever runs first wins and the rest no-op. */

(function () {
  if (window.wfNotifyBound) return;
  window.wfNotifyBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('[data-wf-notify]');
    if (!trigger) return;

    var target = document.querySelector('.wf-newsletter');
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var input = document.getElementById('wf-newsletter-email');
    if (!input) return;
    /* Wait for the smooth scroll to settle before focusing, otherwise the
       focus jump fights the animation. preventScroll stops it snapping. */
    window.setTimeout(function () {
      input.focus({ preventScroll: true });
    }, 600);
  });
})();
